export const EMAIL_REG = /^[\w-.]+@[\w-.]+\.[a-zA-Z]{2,}$/;
export const PHONE_REG = /^[0-9\\-]{4,15}$/;
export const CARD_REG = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{13}$/;
// 只能输入1-20个汉字或者1-40个英文字母（包含空格）
export const NAME_REG = /^([\u4e00-\u9fa5]{1,20}|[a-zA-Z.\s]{1,40})$/;
// 邮箱验证码 4-6位数字
export const EMAIL_CODE_REG = /^[0-9]{4,6}$/;
export const NUMBER_REG = /^[1-9]+[0-9]*$/;

// 事件名称
// 触发“手机输入框”
export const REPORT_CLI_IPT_PHONE = 'CLK_IPT@手机号';
// 触发“邮箱输入框”
export const REPORT_CLI_IPT_MAIL = 'CLK_IPT@邮箱';
// 触发“姓名输入框”
export const REPORT_CLI_IPT_NAME = 'CLK_IPT@姓名';
// 触发“英文名输入框”
export const REPORT_CLI_IPT_ENGLISH_NAME = 'CLK_IPT@英文名';
// 触发“年龄输入框”
export const REPORT_CLI_IPT_AGE = 'CLK_BTN@年龄';
// 触发“点击免费领取按钮”
export const REPORT_CLI_IPT_BTN_GET = 'CLK_BTN@立即获取';
// 触发“吸底按钮”
export const REPORT_CLI_IPT_BTN_SUCTION_BOTTOM = 'CLK_BTN@吸底按钮';
// 触发“侧边按钮”
export const REPORT_CLI_IPT_BTN_SIDE = 'CLK_BTN@侧边按钮';
export const REPORT_PV_RETAINED_CAPITAL = 'PV_留资页';
export const REPORT_UV_RETAINED_CAPITAL = 'UV_留资页';
export const REPORT_LOAD_TIME = 'LOAD_PAGE@加载时长';
export const REPORT_PAGE_PERFORMANCE = 'LOAD_PAGE@页面性能';
export const REPORT_FERM_WRONGFORM = 'ERROR_WRONGFORM@表单报错';
// 触发“挽留”
export const REPORT_CLI_IPT_DETAIN_AGAIN = 'CLK_BTN@挽留我再想想';
export const REPORT_CLI_IPT_DETAIN_SUBMIT = 'CLK_BTN@挽留0元领取';
// 扩科
export const REPORT_CLI_IPT_EXPANSION_CLOSE = 'CLK_BTN@扩科关闭';
export const REPORT_CLI_IPT_EXPANSION_GET = 'CLK_BTN@扩科0元领取';

// 新年卡片赠送
export const REPORT_CLI_CARD_SEND_FRIEND = 'CLK_BTN@赠好友';
export const REPORT_CLI_CARD_RECEIVE_REWORD = 'CLK_BTN@领取贺卡';

// 广点通埋点， 指定l参数
export const GDT_L_PARAMS = [
  '54b21ff7-f593-449a-a80a-083004471c02',
  '4a9ae16b-90f6-4032-8701-4b60db32d0c3',
  'a78931cd-2fa9-4a3e-9e69-69bf77149d60',
  '891e57db-15d3-48d0-b4f9-8ea8be87bfec',
  'dc37ce2e-6dff-43c8-a0ef-6a4cc2a20dcd',
  '9e08d30f-1d34-42f9-a8e2-4697c3b497d3',
  '19a38db3-37a9-40dd-b6ef-47d404f25136',
  '76ef2d1d-4142-43e2-9361-53196cbf8014',
  '52529a77-58ad-4808-a826-b33273d28475',
  '00ab8cc9-a8c9-4469-a9ba-bb8321874a47',
  '26e1fe16-927f-41d1-91d2-e9d86ed5a861',
  '4df91985-0a39-4fc8-a28f-932ccef68cda',
  '2daf9b78-0c42-4565-9ea4-fbf1d0c56b58',
  'f2462f0b-54b7-4274-b2fa-33cfc8a249e3',
  '27f9d04f-04de-45a8-b208-7b79a6d871f6',
];
